import { useRoute, useRouter } from 'vue-router';

export async function clearQueryParam(normalizedPath: string, queryParamName: string) {
  const router = useRouter();
  const route = useRoute();
  try {
    const queries = { ...route.query };
    if (queries[queryParamName] !== undefined) {
      delete queries[queryParamName];
    }
    await router.replace({ path: normalizedPath, query: queries });
  } catch (error) {
    console.error('Failed to replace router query:', error);
  }
}

export const normalizePath = (path: string) => (path.endsWith('/') ? path.slice(0, -1) : path);
